<div class="dm-card-box-edit box-resumo">
      <div class="content">
            <p>O serviço <strong>{{servico.nome}}</strong> já está incluso no seu carrinho.</p>
            <div class="info">
                  <ul>
                        <li>
                              <img width="16px" defaultImage="/images/pixel/bg.png" lazyLoad="/images/template/icons/calendar.svg" alt="Data Utilização" />
                              <span>{{servico.data_utilizacao | date: "dd/MM/yyyy"}}</span>
                        </li> 
                        <li *ngIf="servico.qtd_adt > 0">
                              <img width="16px" defaultImage="/images/pixel/bg.png" lazyLoad="/images/template/icons/people.svg" alt="Adultos" />
                              <span>Adultos: {{servico.qtd_adt}} x {{servico.valor_adt | currency: " R$ "}} = <strong>{{servico.qtd_adt*servico.valor_adt | currency: " R$ "}}</strong></span>
                        </li> 
                        <li *ngIf="servico.qtd_snr > 0">
                              <img width="16px" defaultImage="/images/pixel/bg.png" lazyLoad="/images/template/icons/people.svg" alt="Adultos" />
                              <span>Melhor Idade: {{servico.qtd_snr}} x {{servico.valor_snr | currency: " R$ "}} = <strong>{{servico.qtd_snr*servico.valor_snr | currency: " R$ "}}</strong></span>
                        </li> 
                        <li *ngIf="servico.qtd_chd > 0">   
                              <img width="16px" defaultImage="/images/pixel/bg.png" lazyLoad="/images/template/icons/people.svg" alt="Adultos" />
                              <span>Adultos: {{servico.qtd_chd}} x {{servico.valor_chd | currency: " R$ "}} = <strong>{{servico.qtd_chd*servico.valor_chd | currency: " R$ "}}</strong></span>
                        </li> 
                        <li>
                              <img width="16px" defaultImage="/images/pixel/bg.png" lazyLoad="/images/template/icons/money.svg" alt="Total" />
                              <span>Total: <strong>{{total | currency: " R$ "}}</strong></span>
                        </li>      
                  </ul>
            </div> 
            <div class="content-button">
                  <button type="button" (click)="open()" class="btn-one">
                        <div class="center-flex">
                              <i class="material-icons">edit_note</i>
                              <span>Editar Serviço</span>
                        </div>
                  </button>      
            </div>      
      </div>      
</div>      
